import { EventEmitter, Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';

@Injectable()
export class LoadingIndicatorService {
  onLoadingChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  /**
   * Store all currently active requests
   * @type {Array}
   */
  private requests: HttpRequest<any>[] = [];
  constructor() { }

  /**
   * Stores all currently active requests
   * @param {HttpRequest<any>} req
   */
  onStarted(req: HttpRequest<any>): void {
    this.requests.push(req);
    this.notify();
  }
  /**
   * Removes request from the storage and notifies observers
   */
  onFinished(req: HttpRequest<any>): void {
    const index = this.requests.indexOf(req);
    if (index !== -1) {
      this.requests.splice(index, 1);
    }
    this.notify();
  }
  /**
   * Notifies observers about whether there are any requests on fly
   */
  private notify(): void {
    this.onLoadingChanged.emit(this.requests.length !== 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/helpers/loading-indicator.service.ts